import { Grid2, Grid2Props } from "@mui/material";
import { styled } from "@mui/material/styles";

interface FilterGrid2Props extends Grid2Props {
  spacing?: number;
}

const FilterGrid2 = styled(
  ({ spacing = 2, container = true, ...props }: FilterGrid2Props) => (
    <Grid2 spacing={spacing} container={container} {...props} />
  )
)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  alignItems: "end",
  [theme.breakpoints.down("sm")]: {
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.down("lg")]: {
    marginBottom: theme.spacing(2),
  },
}));

export default FilterGrid2;
